import 'izitoast/dist/css/iziToast.css'
import iziToast, {IziToastSettings} from "izitoast";

const defaultPosition = "bottomRight"

export const createNotifications = (notifOptions: IziToastSettings) => {
    return iziToast.show({...notifOptions, position: defaultPosition });
}

export const createInfoNotification = (notifOptions: IziToastSettings) => {
    return iziToast.info({...notifOptions, position: defaultPosition });
}

export const createSuccessNotification = (notifOptions: IziToastSettings) => {
    return iziToast.success({...notifOptions, position: defaultPosition });
}

export const createErrorNotification = (notifOptions: IziToastSettings) => {
    return iziToast.error({...notifOptions, position: defaultPosition });
}

export const createWarningNotification = (notifOptions: IziToastSettings) => {
    return iziToast.warning({...notifOptions, position: defaultPosition });
}